import React from 'react';
import { makeStyles } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { IconButton } from '@material-ui/core';
//import Searchbar from "../nav/Searchbar"
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux"
import charactor from "../../img/charactor.png"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux";

const useStyles = makeStyles(theme => ({

    container: {
        margin: "0px",
        padding: "0px",
        position: "absolute",
        width: "100%",
        zIndex: "100",
        height: "100%",
        // opacity: "0.9",
        transition: "all ease 3s 3s",
        backgroundColor: " rgba(0, 0, 0, 0.3);",
        touchAction: "none",

    },
    box: {
        display: "flex",
        flexDirection: "column",
        //alignItems: "center",
        // justifyContent: "center",
        width: "80%",
        height: "100%",
        padding: "30px 2% 0px",
        backgroundColor: "#fff",

    },
    login: {
        width: "100%",
        height: "50px",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        fontSize: "1.2rem",
        fontWeight: "bold",
        borderRadius: "30px",
        border: "none",
    },
    userinfo: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "10px",
        display: "flex",

        "& img": {
            width: "120px",
            //   height: "80px",
            backgroundColor: "#f3f3f3",
            borderRadius: "120px"
        },
        "& div[id='info']": {
            width: "150px",
            textAlign: "center",
            "& div": {
                //   textAlign: "center",
                color: "white",
                fontSize: "1.2rem",
                fontWeight: 500,
                margin: "10px 0px",
                overflow: "hidden",
                // webkitLineClamp: 1,
                // webkitBoxOrient: "vertical"
            },

            "& a": {
                color: "white",
                fontSize: "1.2rem",
                fontWeight: 500,
                margin: "10px 0px",
                //  textAlign: "center",
                textDecoration: "none"

            }

        }

    },
    register: {
        width: "100%",
        height: "50px",
        backgroundColor: theme.palette.secondary.main,
        color: "#fff",
        fontSize: "1.2rem",
        fontWeight: "bold",
        borderRadius: "30px",
        border: "none",
    },
    searchBar: {
        width: "100%",
        height: "50px",
        backgroundColor: "#f2f2f2",
        borderRadius: "30px",
        border: "none",
        marginTop: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",



    },
    list: {
        width: "100%",
        margin: "10px 2px",
        fontSize: "1.2rem",
        fontWeight: "bold",
        "& span": {
            padding: "5px",

        },
        "& button[id='icon']": {
            float: "right",
            padding: "0px",
        },

        "& button[id='menu']": {
            backgroundColor: "#fff",
            border: "none",
            fontSize: "1.2rem",
            fontWeight: "bold",
            "& ~ul": {
                color: "gray",
                display: "block",
                listStyle: "none",
                "& li": {
                    padding: "5px",
                },
                "& li:hover": {
                    color: theme.palette.secondary.main,
                }
            },
        },
        closeButton: {
            width: "84%",
            padding: "0px",
            color: "#fff",
            fontSize: "1.2rem",
            fontWeight: "bold",
            height: "10px",
            background: "linear-gradient(150deg, #aaf0d1 20%, #50bcdf 80%)",
            border: "none"
        }
    }
}
)
);

const MenuDrawer = () => {

    const styles = useStyles();
    const history = useHistory();
    const [open1, setOpen1] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const { user } = useSelector(state => ({ ...state }))
    const dispatch = useDispatch()

    const logout = () => {
        window.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_KEY}`);
        dispatch({
            type: "LOGOUT",
            payload: null
        })
    }

    return (
        <div className={styles.container}>
            <div className={styles.box}>

                {!user ?
                    <>
                        <button className={styles.login} onClick={() => history.push("/login")}>SurBay 로그인</button>
                        <br />
                        <button className={styles.register} onClick={() => history.push("/agreement")}>SurBay 회원가입</button>
                    </> :
                    <>
                        <div className={styles.userinfo}>
                            <img src={charactor} alt="loginimg" />
                            <div id='info'>
                                <div>{user.name}</div>
                                <div>{user.credit} 크레딧</div>
                                <Link to="/mypage">마이페이지</Link>
                            </div>
                        </div>
                        <br />
                        <button className={styles.register} onClick={logout}>로그아웃</button>
                    </>
                }
                <br />
                <div className={styles.list} onClick={() => history.push("/")}>
                    <span>
                        Home
                    </span>
                    <IconButton id="icon">
                        <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                </div>
                <div className={styles.list} onClick={() => history.push("/about")}>
                    <span>
                        About SurBay
                    </span>
                    <IconButton id="icon">
                        <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                </div>
                <div className={styles.list} value="/tip" onClick={() => history.push("/tip")}>
                    <span>
                        Tips
                    </span>
                    <IconButton id="icon">
                        <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                </div>
                <br />
                <div className={styles.list}>
                    <button id="menu" onClick={() => setOpen1(!open1)}>
                        품앗이 +
                    </button>
                    {open1 &&
                        <ul>
                            <li value="/post" onClick={() => history.push("/post")}>리서치 게시판</li>
                            <li value="/write/post" onClick={() => history.push("/write/post")}>리서치 작성</li>
                            <li value="/general" onClick={() => history.push("/general")}>투표 게시판</li>
                            <li value="/write/general" onClick={() => history.push("/write/general")}>투표 작성</li>
                        </ul>
                    }
                </div>
                <div className={styles.list}>
                    <button id="menu" onClick={() => setOpen2(!open2)}>
                        교환 +
                    </button>
                    {open2 &&
                        <ul>
                            <li>모바일 교환권</li>
                            <li>My 사물함</li>
                        </ul>
                    }
                </div>
                <div className={styles.list} value="/notice" onClick={() => history.push("/notice")}>
                    <button id="menu" >
                        공지사항
                    </button>
                </div>
            </div>
            {/* <button className={styles.closeButton} id="closeBtn">Close</button> */}
        </div>

    );
};

export default MenuDrawer;